import React from "react";
import {
    IconAlertCircle,
    IconCircleCheck,
    IconCircle as SignBadgeCircle,
    IconInfoCircle
} from '@tabler/icons-react';
import Icon from "./Icon";

const StatusIcon = ({type, size="large", ...props}) => {
    let color;
    let SelectedIcon;
    switch (type) {
    case 'error':
        color = 'status-critical';
        SelectedIcon = IconAlertCircle;
        break;
    case 'warning':
        color = 'status-warning';
        SelectedIcon = IconAlertCircle;
        break;
    case 'info':
        color = 'text-info';
        SelectedIcon = IconInfoCircle;
        break;
    case 'not_completed':
        color = "border";
        SelectedIcon = SignBadgeCircle;
        break;
    case 'ok':
    default:
        color = 'status-ok';
        SelectedIcon = IconCircleCheck;
    }
    return (<Icon SelectedIcon={SelectedIcon} color={color} size={size} {...props} />);
};

export default (StatusIcon);